import { AppDispatch } from '@/app/store';
import { Outlet } from 'react-router-dom';
import { clearFormState, clearLetterDraftId, getLetterSent } from '@/services/createFormSlice';
import { clearLetterSbpState } from '@/services/sbpSlice';
import { useAppDispatch, useAppSelector } from '@/app/hooks';
import React, { FC, ReactElement, useEffect } from 'react';

export const LetterBlock: FC = (): ReactElement => {
  const dispatch: AppDispatch = useAppDispatch();

  const isLetterSent: boolean = useAppSelector(getLetterSent);

  useEffect(() => {
    return (): void => {
      if (isLetterSent) {
        dispatch(clearFormState());
        dispatch(clearLetterSbpState());
      }
    };
  }, [dispatch, isLetterSent]);

  useEffect(() => {
    return (): void => {
      dispatch(clearLetterDraftId());
    };
  }, [dispatch]);

  return <Outlet />;
};
